import { render, staticRenderFns } from "./pc-distributed-item.vue?vue&type=template&id=73c81c26"
import script from "./pc-distributed-item.vue?vue&type=script&lang=js"
export * from "./pc-distributed-item.vue?vue&type=script&lang=js"
import style0 from "./pc-distributed-item.vue?vue&type=style&index=0&id=73c81c26&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports